import Image from "next/image";
import { useEffect, useState } from "react";
import RandomImageComponent from "./PoojaRandomDesignImageComponent";
import { formatAmountPutComma } from "@/utils/utils";
import { cdnBaseURL } from '@/commons/constants';

const PoojaImageComponent = ({
                               imageUrl,
                               altText,
                               poojaData,
                               handlePoojaItemClick,
                               postUserWishlistApi,
                               language,
                               location
                             }) => {
  const [isHovered, setISHovered] = useState(false);
  const [shareUrl, setShareUrl] = useState("");

  const SliceText = ({ text }) => {
    return (
      <h3 className="text-BluntRed w-full font-semibold text-base sm:text-lg lg:text-xl text-left leading-tight line-clamp-2">
        {text}
      </h3>
    );
  };

  const images = [
    {
      src: "/icons/Group6903.svg",
      alt: "Image 1",
      style: { marginTop: "-4px" },
    },
    {
      src: "/icons/Group6899.svg",
      alt: "Image 3",
      style: { paddingBottom: "65px", marginTop: "15px" },
    },
  ];

  const shareViaWhatsApp = () => {
    const message = `Hi, I am planning to book this puja ${shareUrl}. Please respond to me on whatsapp here`;
    window.open(`https://wa.me/?text=${encodeURIComponent(message)}`);
  };

  useEffect(() => {
    if (poojaData) {
      const url = `${process.env.NEXT_PUBLIC_SITE_URL}/${language}/${location}/pooja/${poojaData?.slug}`;
      setShareUrl(url);
    }
  }, [poojaData, language, location]);

  return (
    <div className="group flex flex-col items-start cursor-pointer justify-center relative w-full max-w-[500px]">
      {/* Decorative top images */}
      <div className="flex flex-row z-10 justify-center items-center w-full absolute -top-5 h-12">
        <RandomImageComponent images={images} />
      </div>

      {/* Main card container */}
      <div
        className="relative w-full aspect-square overflow-hidden rounded-lg sm:rounded-xl md:rounded-2xl shadow-md bg-white hover:shadow-xl transition-shadow duration-300 ease-in-out"
        onMouseEnter={() => setISHovered(true)}
        onMouseLeave={() => setISHovered(false)}
      >
        {/* Image */}
        <div
          className="relative w-full h-full"
          onClick={() => handlePoojaItemClick(poojaData)}
        >
          <Image
            src={
              poojaData.media && poojaData.media.length > 0
                ? imageUrl?.replace("bmpassets.s3.ap-south-1.amazonaws.com",cdnBaseURL)
                : "/images/aigenerated/Deities.jpeg"
            }
            alt={altText}
            fill
            sizes="(max-width: 640px) 100vw, (max-width: 768px) 50vw, (max-width: 1024px) 33vw, 25vw"
            className="sm:object-cover object-contain"
            priority={false}
          />
        </div>

        {/* Action buttons overlay */}
        <div className="absolute bottom-2 sm:bottom-3 md:bottom-4 lg:bottom-5 right-2 sm:right-3 md:right-4 lg:right-5 flex flex-col gap-2 lg:gap-3 opacity-0 group-hover:opacity-100 transition-opacity duration-200">
          {/* Wishlist button */}
          <button
            onClick={() => postUserWishlistApi(poojaData)}
            className="rounded-full bg-black/30 hover:bg-black/20 backdrop-blur-md p-1.5 sm:p-2 w-8 sm:w-10 md:w-11 lg:w-12 h-8 sm:h-10 md:h-11 lg:h-12 flex items-center justify-center transition-all duration-200 hover:scale-110"
            aria-label="Add to wishlist"
          >
            <div className="relative w-4 sm:w-5 md:w-6 h-4 sm:h-5 md:h-6">
              <Image
                src="/icons/whiteHeart.svg"
                alt="Add to wishlist"
                fill
                className="object-contain"
              />
            </div>
          </button>

          {/* Share button */}
          <button
            onClick={shareViaWhatsApp}
            className="rounded-full bg-black/30 hover:bg-black/20 backdrop-blur-md p-1.5 sm:p-2 w-8 sm:w-10 md:w-11 lg:w-12 h-8 sm:h-10 md:h-11 lg:h-12 flex items-center justify-center transition-all duration-200 hover:scale-110"
            aria-label="Share on WhatsApp"
          >
            <div className="relative w-4 sm:w-5 md:w-6 h-4 sm:h-5 md:h-6">
              <Image
                src="/icons/share.svg"
                alt="Share"
                fill
                className="object-contain"
              />
            </div>
          </button>
        </div>
      </div>

      {/* Card details */}
      <div className="w-full mt-2 sm:mt-3 md:mt-4 mb-3 sm:mb-4 md:mb-5 flex flex-col gap-2">
        <SliceText text={altText} />

        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-1 sm:gap-2">
          <div className="text-Default font-medium">
            <div className="text-xs sm:text-sm text-gray-600">
              {poojaData.price ? "Packages Starting From" : "Price On Request"}
            </div>
            {poojaData.price && (
              <span className="text-BluntRed font-bold text-base sm:text-lg md:text-xl">
                ₹ {formatAmountPutComma(poojaData.price)}
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PoojaImageComponent;